import React, { useEffect, useState } from 'react';
import API from '../services/api';
import Sidebar from '../components/AnalyticsSidebar';
import './_analytics.css';

export default function WardenAssignments() {
  const [wardens, setWardens] = useState([]);
  const [hostler, setHostler] = useState([]);      // selected ids
  const [nonHostler, setNonHostler] = useState([]); // selected ids
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    (async () => {
      try {
        const [{ data: w }, { data: a }] = await Promise.all([
          API.get('/wardens'),              // all wardens
          API.get('/wardens/assignments'),  // current config
        ]);
        setWardens(w || []);
        setHostler((a?.hostler || []).map(x=>x._id));
        setNonHostler((a?.nonHostler || []).map(x=>x._id));
      } catch (e) { alert(e.response?.data?.msg || e.message); }
      finally { setLoading(false); }
    })();
  }, []);

  const toggle = (list, setList, id) => {
    setList(prev => prev.includes(id) ? prev.filter(x=>x!==id) : [...prev, id]);
  };

  const save = async () => {
    try {
      await API.put('/wardens/assignments', { hostler, nonHostler });
      alert('Assignments saved.');
    } catch (e) { alert(e.response?.data?.msg || e.message); }
  };

  return (
    <div className="split-layout">
      <Sidebar />
      <div className="table-wrapper">
        <div className="table-header-row">
          <h2>🛎️ Warden Assignments</h2>
          <div className="btn-row">
            <button className="action-btn blue" onClick={save}>💾 Save</button>
          </div>
        </div>

        <p style={{opacity:.75}}>Select which wardens handle <b>hostler</b> vs <b>non-hostler</b> student requests.</p>

        <div style={{display:'grid',gridTemplateColumns:'1fr 1fr',gap:16, marginTop:12}}>
          <div className="card">
            <h3>Hostler</h3>
            {wardens.map(w => (
              <label key={w._id} style={{display:'flex',alignItems:'center',gap:8, padding:'6px 0'}}>
                <input type="checkbox" checked={hostler.includes(w._id)} onChange={()=>toggle(hostler,setHostler,w._id)} />
                <span>{w.name} <span style={{opacity:.6, fontSize:12}}>({w.email})</span></span>
              </label>
            ))}
          </div>

          <div className="card">
            <h3>Non-Hostler</h3>
            {wardens.map(w => (
              <label key={w._id} style={{display:'flex',alignItems:'center',gap:8, padding:'6px 0'}}>
                <input type="checkbox" checked={nonHostler.includes(w._id)} onChange={()=>toggle(nonHostler,setNonHostler,w._id)} />
                <span>{w.name} <span style={{opacity:.6, fontSize:12}}>({w.email})</span></span>
              </label>
            ))}
          </div>
        </div>

        <style>{`
          .card{background:#fff;border:1px solid #e5e7eb;border-radius:10px;padding:12px}
          h3{margin:0 0 8px}
        `}</style>

        {loading && <p style={{opacity:.7}}>Loading…</p>}
      </div>
    </div>
  );
}
